import { createFileRoute } from '@tanstack/react-router';
import { DispatchesRegister } from '../../../../features/sales-invoicing/DispatchesRegister';

/** Owned by G23. Dispatches register. */
export const Route = createFileRoute('/_authenticated/sales-invoicing/dispatches/')({
  component: DispatchesRegister,
});
